import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./styles/base.css";
import "./styles/components.css";
import "./styles/shell.css";
import { Boot } from "./app/Boot.js";
import { captureJoinConfirmation } from "./auth/joinConfirmation.js";
import { passwordRecoveryCoordinator } from "./auth/passwordRecovery.js";
import { activationCoordinator } from "./auth/activation.js";
import {
  applyThemeToDocument,
  buildTimeThemeName,
  getTheme,
  readModePreference,
  resolveMode,
  resolveThemeName,
} from "./theme/index.js";

activationCoordinator.capture(new URL(window.location.href), () => {
  window.history.replaceState(window.history.state, "", window.location.pathname);
});

passwordRecoveryCoordinator.capture(new URL(window.location.href), () => {
  window.history.replaceState(window.history.state, "", window.location.pathname);
});

const joinConfirmationAttempt = captureJoinConfirmation(new URL(window.location.href), () => {
  window.history.replaceState(window.history.state, "", window.location.pathname);
});

// Paint the build-time theme before React mounts so the first frame is styled;
// the ThemeProvider re-applies once `/api/config.theme` is known.
applyThemeToDocument(getTheme(resolveThemeName(buildTimeThemeName())), resolveMode(readModePreference()));

const container = document.getElementById("root");
if (!container) throw new Error("#root missing from index.html");

createRoot(container).render(
  <StrictMode>
    <Boot joinConfirmationAttempt={joinConfirmationAttempt} />
  </StrictMode>,
);
